module.exports = __webpack_public_path__ + "img/pdf.94616447.svg";